import { OrderStatusLiterals } from '@trukt/types/Order';
import { ColorOptionLiterals } from './types';

const TEXT_CLASS_NAME_MAP: Record<OrderStatusLiterals, string> = {
  submitted: 'text-order-status-submitted',
  'on hold': 'text-order-status-on-hold',
  scheduled: 'text-order-status-scheduled',
  'picked up': 'text-order-status-picked-up',
  delivered: 'text-order-status-delivered',
  canceled: 'text-order-status-canceled',
};

const BG_CLASS_NAME_MAP: Record<OrderStatusLiterals, string> = {
  submitted: 'bg-order-status-submitted',
  'on hold': 'bg-order-status-on-hold',
  scheduled: 'bg-order-status-scheduled',
  'picked up': 'bg-order-status-picked-up',
  delivered: 'bg-order-status-delivered',
  canceled: 'bg-order-status-canceled',
};

const FILL_CLASS_NAME_MAP: Record<OrderStatusLiterals, string> = {
  submitted: 'fill-order-status-submitted',
  'on hold': 'fill-order-status-on-hold',
  scheduled: 'fill-order-status-scheduled',
  'picked up': 'fill-order-status-picked-up',
  delivered: 'fill-order-status-delivered',
  canceled: 'fill-order-status-canceled',
};

export const getOrderStatusColorClassName = (
  status: OrderStatusLiterals,
  option: ColorOptionLiterals,
) => {
  switch (option) {
    case 'bg':
      return BG_CLASS_NAME_MAP[status];
    case 'fill':
      return FILL_CLASS_NAME_MAP[status];
    default:
      return TEXT_CLASS_NAME_MAP[status];
  }
};
